import React from "react";
import Logo from "../../../../assets/landing/medellin.png";
// style components
import { Image, Divider } from "antd";

export const HeaderLogin = () => {
  return (
    <div className="login-header-wrapper text-center w-100">
      <div className="d-flex justify-content-center mb-2">
        <Image
          src={Logo}
          preview={false}
          className="login-header-logo img-fluid mx-auto"
          style={{ maxHeight: "56px", width: "auto" }}
          alt="Alcaldía de Medellín"
        />
      </div>
      <div className="login-header-title font-color-005CC6 font-family-Montserrat-Bold text-center mb-1">
        Secretaría de Cultura Ciudadana, convocatorias de fomento y estímulos para el arte y la cultura
      </div>
      <Divider style={{ margin: "10px 0" }} />
      <div className="font-size-13px font-family-Montserrat-Bold text-start mb-2">
        Ingresa tus datos para iniciar sesión
      </div>
    </div>
  );
};